import axios from "axios";

export const fetchClient = axios.create();
